export const executeNetworkAsync = async (callback: any) => {
  try {
    const response = await callback();
    return [response.data, null];
  } catch (error: any) {
    console.error("executeNetworkAsync", error);
    return [null, { error: true, message: error.response?.data?.message }];
  }
};
